import { render, staticRenderFns } from "./SimpleList.vue?vue&type=template&id=138d4ca4&scoped=true"
import script from "./SimpleList.vue?vue&type=script&lang=js"
export * from "./SimpleList.vue?vue&type=script&lang=js"
import style0 from "./SimpleList.vue?vue&type=style&index=0&id=138d4ca4&prod&lang=scss&scoped=true"
import style1 from "./SimpleList.vue?vue&type=style&index=1&id=138d4ca4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d4ca4",
  null
  
)

export default component.exports